import { useQuery } from "@tanstack/react-query";
export const createAchievementsQueries = (requests, queryClient) => ({
    useListAchievements: (params, options = {}) => useQuery({
        queryKey: ["achievements", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listAchievements(params);
        },
        ...options,
    }),
    useFindAchievement: (params, options = {}) => useQuery({
        queryKey: ["achievements", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findAchievement(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map